import { RefreshCw, Trash } from 'lucide-react';
import React, { useEffect, useState } from 'react';

const Container = ({title='',rightSection=[],onClick,onDeleteClick,deleteButton=false,children}) => {
  return (
    <div style={styles.page} key={title?.toLowerCase().replace(/\s+/g, '-')}>
      <div style={styles.container}>
        <header style={styles.header}>
            <div>
              <h1 style={styles.logo}>BookFast <span style={styles.logoAccent}>Connect</span></h1>
              <p style={styles.subtext}>{title}</p>
            </div>
            <div style={{display:'flex'}}>
              {rightSection}
                <button onClick={onClick} style={refreshBtn}><RefreshCw size={14} style={{marginRight:'10px'}} /> Refresh</button>
                {deleteButton && <button onClick={onDeleteClick} style={{...refreshBtn,backgroundColor:'red'}}><Trash size={14} style={{marginRight:'10px'}} /> Clear History</button>}
            </div>
        </header>
        {children}
      </div>
    </div>
  );
};

const styles = {
  page: { backgroundColor: '#f1f5f9', height: '100%', padding: '30px 20px', fontFamily: 'sans-serif' },
  container: { margin: '0 auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  logo: { fontSize: '24px', fontWeight: '900', color: '#0f172a', margin: 0 },
  logoAccent: { color: '#4f46e5' },
  subtext: { color: '#64748b', fontSize: '13px', margin: '2px 0 0 0' },
  statusBadge: { backgroundColor: 'white', padding: '6px 14px', borderRadius: '30px', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid #e2e8f0' },
  dot: { width: '7px', height: '7px', backgroundColor: '#10b981', borderRadius: '50%' },
};
const refreshBtn = { padding: '10px 20px',display:'flex',alignItems:'center',marginLeft:'10px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' };


export default Container;